import { useLocation, useMatches } from 'react-router-dom';
import { useEffect } from 'react';
import { trackPageView } from '@/services/adobe-analytics/adobe-analytics-service';

export function useTrackPageView() {
  const location = useLocation();
  const matches = useMatches();

  // track page view every time location changes
  useEffect(() => {
    const pageTitle =
      matches[matches.length - 1]?.handle?.title ?? location.pathname;
    trackPageView(pageTitle);
  }, [location, matches]);
}
